import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'vehicle_rental_list';
export const route = 'vehicle_rental_list/';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "vehicleRentalList" */
'../../components/VehicleRentalList')));